import React, { useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Style from "../../styles/js/StyleNotifications.js";
import UploadImage from "./UploadImage.js";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Axios from "axios";
import * as Constants from "../../consts/Constants.js";
import { CustomCheckbox } from "../../components/common/CustomCheckbox.js";

export default function InputsForm({ state, handleChange }) {
  const style = Style();

  const [categories, setCategories] = React.useState([]);
  const [subcategories, setSubcategories] = React.useState([]);

  const getCategories = () => {
    Axios.get(Constants.FINAL_URL_CATEGORIES).then((response) => {
      let data = response.data;
      setCategories(data);
    });
  };

  const getSubcategories = (category) => {
    Axios.get(
      Constants.FINAL_URL_CATEGORIES +
        category +
        "/" +
        Constants.URL_SUBCATEGORIES
    ).then((response) => {
      let data = response.data;
      setSubcategories(data);
    });
  };

  const handleCategoriesChange = (event) => {
    getSubcategories(event.target.value);
    handleChange(event);
  };

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <div className={style.inputsForm}>
      <div className={style.inputRow}>
        <FormControl className={style.formControl}>
          <InputLabel id="demo-simple-select-label">Categoria</InputLabel>
          <Select
            name="category"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            onChange={handleCategoriesChange}
            value={state.category}
          >
            {categories.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl className={style.formControl}>
          <InputLabel id="demo-simple-select-label">Subcategoria</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            onChange={handleChange}
            value={state.subcategory}
            name="subcategory"
          >
            <MenuItem key={0} value={-1}>
              General
            </MenuItem>
            {subcategories.map((item, index) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControlLabel
          checked={state.alert}
          name="alert"
          onChange={handleChange}
          control={<CustomCheckbox />}
          label="Alerta"
          labelPlacement="start"
        />
      </div>
      <TextField
        name="title"
        className={style.input}
        required
        label="Titulo"
        variant="outlined"
        onChange={handleChange}
        value={state.title}
      />
      <TextField
        name="body"
        className={style.input}
        required
        label="Texto de la notification"
        variant="outlined"
        onChange={handleChange}
        value={state.body}
      />
      <TextField
        name="link"
        className={style.input}
        required
        label="Link"
        variant="outlined"
        onChange={handleChange}
        value={state.link}
      />
      <UploadImage handleChange={handleChange} />
    </div>
  );
}
